import { createSlice  } from '@reduxjs/toolkit';
import { getPageFilter, saveFilters } from "../../utils/index";
import apiservice from '../../services/apiservice';

const initialState = {
    invoiceList: {
      requesting: false,
      items: [],
      pagination: {
		  current_page: 1,
		  per_page: 10,
		  total: 0,
	  },
      errors: null,
      success: false,
      filters: getPageFilter('invoiceList'),
    },
    invoiceDetails: {
      requesting: false,
      errors: null,
      success: false,
      data: null,
    },
    isLoggedInXero: apiservice.getLocalStoredValue('xero_status'),
    employeesOnInvoiceCost: {
        requesting: false,
        items: [],
        errors: null,
      success: false,
    },
    employeesOnInvoiceOTAbsences: {
        requesting: false,
        items: [],
        errors: null,
      success: false,
    }
};

export const invoiceSlice = createSlice({
  name: 'invoice',
  initialState,
  reducers: {
    getInvoiceList: (state, action) => {
        state.invoiceList.requesting = true;
        state.invoiceList.errors = null;
        state.invoiceList.items = [];
        state.invoiceList.success = false;
        state.invoiceList.filters = action.payload;
        saveFilters('invoiceList', action.payload);
    },
    getInvoiceListSuccess: (state, action) => {
		const { data, current_page, per_page, total} = action.payload;
        state.invoiceList.requesting = false;        
        state.invoiceList.items = data;
        state.invoiceList.success = true; 
        state.invoiceList.pagination.current_page = current_page;
        state.invoiceList.pagination.per_page = per_page;
        state.invoiceList.pagination.total = total;
    },
    getInvoiceListFail: (state, action) => {        
        state.invoiceList.requesting = false;
        state.invoiceList.errors = action.payload;
    },
    getInvoiceDetails: (state) => {
        state.invoiceDetails.requesting = true;
        state.invoiceDetails.errors = null;
        state.invoiceDetails.data = null;
        state.invoiceDetails.success = false; 
    },
    getInvoiceDetailsSuccess: (state, action) => {
        state.invoiceDetails.requesting = false;
        state.invoiceDetails.data = action.payload;
        state.invoiceDetails.success = true; 
    },
    getInvoiceDetailsFail: (state, action) => {        
        state.invoiceDetails.requesting = false;
        state.invoiceDetails.errors = action.payload;
    },
    doInvoiceCreate: (state) => {
        state.invoiceDetails.requesting = true;
        state.invoiceDetails.errors = null;
        state.invoiceDetails.success = false; 
    },
    doInvoiceUpdate: (state) => {
        state.invoiceDetails.requesting = true;
        state.invoiceDetails.errors = null;
        state.invoiceDetails.success = false; 
    },
    doInvoiceDelete: (state) => {
        state.invoiceDetails.requesting = true;
        state.invoiceDetails.errors = null;
        state.invoiceDetails.data = null;
        state.invoiceDetails.success = false; 
    },
    doInvoiceProgressUpdate: (state) => {
        state.invoiceDetails.requesting = true;
        state.invoiceDetails.errors = null;
        state.invoiceDetails.success = false; 
    },
    doGenerateMonthlyInvoice: (state) => {
        state.invoiceDetails.requesting = true;
        state.invoiceDetails.errors = null;
        state.invoiceDetails.success = false; 
    },
    doCreateSelectionNoticeInvoice: (state) => {
        state.invoiceDetails.requesting = true;
        state.invoiceDetails.errors = null;
        state.invoiceDetails.success = false; 
    },
    doInvoicesPushToXero: (state) => {
        state.invoiceDetails.requesting = true;
        state.invoiceDetails.errors = null;
        state.invoiceDetails.success = false; 
    },
    getMyInvoiceDetails: (state) => {
        state.invoiceDetails.requesting = true;
        state.invoiceDetails.errors = null;
        state.invoiceDetails.data = null;
        state.invoiceDetails.success = false; 
    },
    getEmployeesOnInvoice: (state) => {
        state.employeesOnInvoiceCost.requesting = true;
        state.employeesOnInvoiceCost.errors = null;
        state.employeesOnInvoiceCost.items = [];
        state.employeesOnInvoiceCost.success = false; 
    },
    getEmployeesOnInvoiceSuccess: (state, action) => {
        state.employeesOnInvoiceCost.requesting = false;        
        state.employeesOnInvoiceCost.items = action.payload;
        state.employeesOnInvoiceCost.success = true; 
    },
    getEmployeesOnInvoiceFail: (state, action) => {        
        state.employeesOnInvoiceCost.requesting = false;
        state.employeesOnInvoiceCost.errors = action.payload;
    },

    getEmployeesOnInvoiceOTAbsences: (state) => {
        state.employeesOnInvoiceOTAbsences.requesting = true;
        state.employeesOnInvoiceOTAbsences.errors = null;
        state.employeesOnInvoiceOTAbsences.items = [];
        state.employeesOnInvoiceOTAbsences.success = false; 
    },
    getEmployeesOnInvoiceOTAbsencesSuccess: (state, action) => {
        state.employeesOnInvoiceOTAbsences.requesting = false;        
        state.employeesOnInvoiceOTAbsences.items = action.payload;
        state.employeesOnInvoiceOTAbsences.success = true; 
    },
    getEmployeesOnInvoiceOTAbsencesFail: (state, action) => {        
        state.employeesOnInvoiceOTAbsences.requesting = false;
        state.employeesOnInvoiceOTAbsences.errors = action.payload;
    },
    
  },
})

export const { 
    getInvoiceList, getInvoiceListSuccess, getInvoiceListFail,
    getInvoiceDetails, getInvoiceDetailsSuccess, getInvoiceDetailsFail,
    doInvoiceCreate, doInvoiceUpdate, doInvoiceDelete,
    doInvoiceProgressUpdate,
    doXeroConnection, doXeroConnectionSuccess, doXeroConnectionFail,
    doGenerateMonthlyInvoice, doCreateSelectionNoticeInvoice,
    doInvoicesPushToXero, getMyInvoiceDetails,
    getEmployeesOnInvoice, getEmployeesOnInvoiceSuccess, getEmployeesOnInvoiceFail,
    getEmployeesOnInvoiceOTAbsences, getEmployeesOnInvoiceOTAbsencesSuccess, getEmployeesOnInvoiceOTAbsencesFail
} = invoiceSlice.actions

export default invoiceSlice.reducer